import { Box, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function FrequencyChangeDisplay({ change }) {
    const newFreq = change.newFrequency
    const newLabel = `${newFreq.interval} ${newFreq.period}`

    return (
        <Box>
            <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                Frequency change
            </Typography>
            <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{
                    border: "1px solid",
                    borderColor: "warning.light",
                    borderRadius: 1,
                    p: 1.5,
                    bgcolor: "warning.lighter",
                }}
            >
                <Box
                    sx={{
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 1,
                        bgcolor: "action.hover",
                        border: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        {change.oldText || "0 Unknown"}
                    </Typography>
                </Box>
                <Iconify icon="mdi:arrow-right" sx={{ color: "warning.main" }} />
                <Box
                    sx={{
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 1,
                        bgcolor: "warning.lighter",
                        border: "1px solid",
                        borderColor: "warning.main",
                    }}
                >
                    <Typography variant="body2" fontWeight="bold">
                        {newLabel}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    )
}
